<script>
    import { token } from "./store/token.js";
    import { canAccess } from "./store/permissions.js";

    let promo_code_list;
    let promo_code;

    const fetch_promo_code_list = async () => {
        const response = await fetch(
            //`http://localhost:1337/admin/promo/list`, {
            //`https://staging.api.control.vollume.com/admin/promo/list`, {
            `${process.env.API_ROOT}/admin/promo/list`, {
            headers: {
                Authorization: "Bearer " + $token,
            },
        });

        promo_code_list = await response.json();
        return promo_code_list;
    };

    const activate_code = async (code) => {
        const response = await fetch(
            //`http://localhost:1337/admin/promo/${code}/activate`,
            //`https://staging.api.control.vollume.com/admin/promo/${code}/activate`,
            `${process.env.API_ROOT}/admin/promo/${code}/activate`,
            {
                headers: {
                    Authorization: "Bearer " + $token,
                },
                method: "post",
            }
        );
        const json = await response.json();
        await fetch_promo_code_list();
        return json;
    };

    const deactivate_code = async (code) => {
        const response = await fetch(
            //`http://localhost:1337/admin/promo/${code}/deactivate`,
            //`https://staging.api.control.vollume.com/admin/promo/${code}/deactivate`,
            `${process.env.API_ROOT}/admin/promo/${code}/deactivate`,
            {
                headers: {
                    Authorization: "Bearer " + $token,
                },
                method: "post",
            }
        );
        const json = await response.json();
        await fetch_promo_code_list();
        return json;
    };

    const delete_code = async (code) => {
        var result = confirm(
            "Do you really want delete promo code " + code + "?"
        );

        if (!result) {
            return;
        }

        const response = await fetch(
            //`http://localhost:1337/admin/promo/${code}`,
            //`https://staging.api.control.vollume.com/admin/promo/${code}`,
            `${process.env.API_ROOT}/admin/promo/${code}`,
            {
                headers: {
                    Authorization: "Bearer " + $token,
                },
                method: "delete",
            }
        );
        const json = await response.json();
        await fetch_promo_code_list();
        return json;
    };

    const create_promo_code = async () => {
        const response = await fetch(
            //`http://localhost:1337/admin/promo/create`,
            //`https://staging.api.control.vollume.com/admin/promo/create`,
            `${process.env.API_ROOT}/admin/promo/create`,
            {
                headers: {
                    Authorization: "Bearer " + $token,
                },
                method: "post",
                body: JSON.stringify({
                    promo_code: promo_code,
                }),
            }
        );
        const json = await response.json();

        promo_code = "";

        await fetch_promo_code_list();

        return json;
    };
</script>

<div class="ds-page">
    <div class="ds-page-header">
        <div>
            <h1 class="ds-page-title">Promo codes</h1>
            <p class="ds-page-subtitle">Create and manage promo codes</p>
        </div>
    </div>

    {#if $canAccess.promo_codes}
    <div class="ds-card promo-toolbar">
        <input
            class="ds-input promo-input"
            bind:value={promo_code}
            placeholder="Promo code"
        />

        <button
            class="ds-btn ds-btn-primary"
            on:click={() => {
                create_promo_code();
            }}>Create code</button
        >
    </div>
    {/if}

    <div class="ds-card">
        {#await fetch_promo_code_list()}
            <div class="ds-loading">
                <div class="ds-spinner"></div>
                Loading promo codes
            </div>
        {:then xxx}
            {#if promo_code_list.records.length > 0}
                <table class="ds-table">
                    <thead>
                        <tr>
                            <th>Code</th>
                            <th>Created at</th>
                            <th>Is active</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {#each promo_code_list.records as promo_code, i}
                            <tr>
                                <td>{promo_code.code}</td>
                                <td>{promo_code.created_at}</td>
                                <td>
                                    <span
                                        class="ds-chip"
                                        class:ds-chip-ok={promo_code.is_active}
                                        class:ds-chip-warn={!promo_code.is_active}
                                    >
                                        {promo_code.is_active ? "active" : "inactive"}
                                    </span>
                                </td>
                                <td>
                                    {#if $canAccess.promo_codes}
                                    <button
                                        class="ds-btn ds-btn-danger ds-btn-sm"
                                        on:click={() => {
                                            delete_code(promo_code.code);
                                        }}>Delete</button
                                    >
                                    {#if promo_code.is_active}
                                        <button
                                            class="ds-btn ds-btn-secondary ds-btn-sm"
                                            on:click={() => {
                                                deactivate_code(promo_code.code);
                                            }}>Deactivate</button
                                        >
                                    {:else}
                                        <button
                                            class="ds-btn ds-btn-secondary ds-btn-sm"
                                            on:click={() => {
                                                activate_code(promo_code.code);
                                            }}>Activate</button
                                        >
                                    {/if}
                                    {/if}
                                </td>
                            </tr>
                        {/each}
                    </tbody>
                </table>
            {:else}
                <div class="ds-empty">No promo codes</div>
            {/if}
        {:catch error}
            <p class="ds-error">Failed to load the promo codes.</p>
        {/await}
    </div>
</div>

<style>
    .promo-toolbar {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin-bottom: 1.5rem;
    }
    .promo-input {
        max-width: 320px;
    }
</style>
